import React from "react";
import { icons } from "../../helpers/ListIconsFontawesome";


export const SelectFontawesome = ({ value = "", onChange = () => {} }) => {
  return (
    <>
      {value && (
        <div className="col-12 text-center">
          {/* <h6 className="mb-0">Icono seleccionado</h6> */}
          <i
            className={`${value} fa-3x m-2 hover-icon-selected mb-3 text-center`}
          ></i>
        </div>
      )}

      <div className="col-12" style={{ height: 350, overflowY: "scroll" }}>
        {icons.map((x, index) => {
          let auxClass = "";
          if (value === x) {
            auxClass = " hover-icon-selected ";
          }
          return (
            <i
              key={index}
              onClick={() => {
                onChange(x);
              }}
              className={`${x}  fa-2x m-2 hover-icon  ${auxClass}`}
            ></i>
          );
        })}
      </div>
    </>
  );
};
